// Role Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAIL = 'GET_ROLES_FAIL';
export const GET_ROLES_RESET = 'GET_ROLES_RESET';

export const GET_ROLE_BY_ID = 'GET_ROLE_BY_ID';
export const GET_ROLE_BY_ID_SUCCESS = 'GET_ROLE_BY_ID_SUCCESS';
export const GET_ROLE_BY_ID_FAIL = 'GET_ROLE_BY_ID_FAIL';
export const GET_ROLE_BY_ID_RESET = 'GET_ROLE_BY_ID_RESET';

export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL';
export const CREATE_ROLE_RESET = 'CREATE_ROLE_RESET';

export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = 'UPDATE_ROLE_FAIL';
export const UPDATE_ROLE_RESET = 'UPDATE_ROLE_RESET';

export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL';
export const DELETE_ROLE_RESET = 'DELETE_ROLE_RESET';

export const GET_ROLES_DROPDOWN = 'GET_ROLES_DROPDOWN';
export const GET_ROLES_DROPDOWN_SUCCESS = 'GET_ROLES_DROPDOWN_SUCCESS';
export const GET_ROLES_DROPDOWN_FAIL = 'GET_ROLES_DROPDOWN_FAIL';
export const GET_ROLES_DROPDOWN_RESET = 'GET_ROLES_DROPDOWN_RESET';

// Thunk Actions
export const getRolesApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_ROLES });
		axios
			.get(`${config.api.base_url}/roles`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getRolesData = response.data;
				dispatch({ type: GET_ROLES_SUCCESS, response: getRolesData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_ROLES_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getRoleByIdApi = (id) => {
	return (dispatch) => {
		dispatch({ type: GET_ROLE_BY_ID });
		axios
			.get(`${config.api.base_url}/roles/${id}`, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getRoleData = response.data;
				dispatch({ type: GET_ROLE_BY_ID_SUCCESS, response: getRoleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_ROLE_BY_ID_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const createRoleApi = (data) => {
	return (dispatch) => {
		dispatch({ type: CREATE_ROLE });
		axios
			.post(`${config.api.base_url}/roles`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const createRoleData = response.data;
				dispatch({ type: CREATE_ROLE_SUCCESS, response: createRoleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: CREATE_ROLE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const updateRoleApi = (id, data) => {
	return (dispatch) => {
		dispatch({ type: UPDATE_ROLE });
		axios
			.post(`${config.api.base_url}/roles/${id}`, data, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const updateRoleData = response.data;
				dispatch({ type: UPDATE_ROLE_SUCCESS, response: updateRoleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: UPDATE_ROLE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const deleteRoleApi = (id) => {
	return (dispatch) => {
		dispatch({ type: DELETE_ROLE });
		axios
			.post(`${config.api.base_url}/roles/delete/${id}`, { id }, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const deleteRoleData = response.data;
				dispatch({ type: DELETE_ROLE_SUCCESS, response: deleteRoleData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: DELETE_ROLE_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getRolesDropdownApi = (data) => {
	return (dispatch) => {
		dispatch({ type: GET_ROLES_DROPDOWN });
		axios
			.get(`${config.api.base_url}/roles/dropdown`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getRolesDropdownData = response.data;
				dispatch({ type: GET_ROLES_DROPDOWN_SUCCESS, response: getRolesDropdownData });
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch({ type: GET_ROLES_DROPDOWN_FAIL, response: error.response?.data || errorMsg });
			});
	};
};

export const getRolesReset = () => ({
  type: GET_ROLES_RESET,
});

export const getRoleByIdReset = () => ({
  type: GET_ROLE_BY_ID_RESET,
});

export const createRoleReset = () => ({
  type: CREATE_ROLE_RESET,
});

export const updateRoleReset = () => ({
  type: UPDATE_ROLE_RESET,
});

export const deleteRoleReset = () => ({
  type: DELETE_ROLE_RESET,
});

export const getRolesDropdownReset = () => ({
  type: GET_ROLES_DROPDOWN_RESET,
});

